import { GameShow } from './GameShow';
import { GameList } from './GameList';
import { GameEdit } from './GameEdit';
import { GameCreate } from './GameCreate';

export default {
    list: GameList,
    show: GameShow,
    edit: GameEdit,
    create: GameCreate
};
